import { useEffect } from "react";

type JsonLdProps = {
  id: string;
  data: Record<string, unknown>;
};

export default function JsonLd({ id, data }: JsonLdProps) {
  const json = JSON.stringify(data);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = json;
    document.head.appendChild(script);
    return () => {
      const existing = document.getElementById(id);
      if (existing) {
        document.head.removeChild(existing);
      }
    };
  }, [id, json]);

  return null;
}